import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleService from '../../components/Service';


const Service = () => {
  return (
    <div id="cozumler" className="service__area service__space service__mlr grey-bg pt-195 pb-70 p-relative">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInUp"
            data-wow-duration="1.1s"
          >
            <SectionTitle
              sectionClass="service__section-box text-center pb-35 section-title-fixed-width"
              subTitle="Çözümlerimiz"
              Title="Geliştirdiğimiz Çözümler"
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleService
              itemClass="service__item service__border-1 p-relative fix"
              titleClass="service__title title-color-1"
              btnClass="service__link service__link-color-1"
              Title="Su Altı Robotu (ROV)"
              Description="Gemi bakım ve temizlik süreçlerinde otonom çözümler sunan insansız su altı robotu. Operasyonel verimliliği artıran teknoloji."
              btnText="Detaylar"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleService
              itemClass="service__item service__border-2 p-relative fix"
              titleClass="service__title title-color-2"
              btnClass="service__link service__link-color-2"
              Title="Robot Kol"
              Description="Kesme, kavrama, kurtarma ve onarım gibi görevleri yerine getirebilen çok fonksiyonlu, modüler yapıda manipülatör sistemi."
              btnText="Detaylar"
              btnURL="robotkol"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <SingleService
              itemClass="service__item service__border-3 p-relative fix"
              titleClass="service__title title-color-3"
              btnClass="service__link service__link-color-3"
              Title="Yapay Zeka Destekli Seyir Sistemi"
              Description="Gündüz ve gece koşullarında çalışan, nesne tespiti ve takibi yaparak çarpışma risklerini önceden belirleyen sistem."
              btnText="Detaylar"
              btnURL="seyir"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1s"
          >
            <SingleService
              itemClass="service__item service__border-4 p-relative fix"
              titleClass="service__title title-color-4"
              btnClass="service__link service__link-color-4"
              Title="Kamera ve Sensör Sistemleri"
              Description="Geliştirdiğimiz kamera sistemi ile gerçek zamanlı görüntü işleme ve durumsal farkındalık sağlayan teknolojiler."
              btnText="Detaylar"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.2s"
          >
            <SingleService
              itemClass="service__item service__border-5 p-relative fix"
              titleClass="service__title title-color-5"
              btnClass="service__link service__link-color-5"
              Title="Su Altı Denetim ve Analiz Teknolojileri"
              Description="Su altı yapıların, gemilerin ve deniz araçlarının detaylı denetimi ve analizi için gelişmiş teknolojiler. Yapısal bütünlük, korozyon analizi ve güvenlik değerlendirmeleri için kapsamlı çözümler sunuyoruz."
              btnText="Detaylar"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.3s"
          >
            <SingleService
              itemClass="service__item service__border-6 p-relative fix"
              titleClass="service__title title-color-6"
              btnClass="service__link service__link-color-6"
              Title="Yerli Alt Bileşen Üretimi"
              Description="Deniz araçları için kritik alt bileşenlerin yerli imkanlarla üretimi. Elektronik kartlar, sensörler, aydınlatma sistemleri ve kamera sistemleri gibi bileşenlerin tasarımı ve üretimi."
              btnText="Detaylar"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
